import * as React from 'react';
import { useLocation } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import ProfileDetails from './ProfileDetails';
import authService from '../api-authorization/AuthorizeService';

interface IProps {
    userId: string;
}

export default function ProfileContainer() {
    const location = useLocation();
    const { userId } = location.state as IProps || {
        userId: ""
    }
    const [id, setId] = React.useState(userId);

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        const user = await authService.getUser();
        setId(user.sub);
    }

    return (
        <Grid container spacing={2}>
            {id !== '' &&
                <Grid item md={8} xs={12}>
                    <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12}>
                            <ProfileDetails userId={id} />
                        </Grid>
                    </Grid>
                </Grid>
            }
        </Grid>
    );
}